import React from 'react';
import FakeIconTextGroup from '@/components/Fakes/FakeIconTextGroup';
import FakeTextInfo from '@/components/Fakes/FakeTextInfo';
// import Card, { CARD_COLOR } from '@gerenciatd/next.components.card-n';
import styles from '../styles';

export const COMPONENT_NAME = 'SecureStateCardFake';

const SecureStateCardFake = ({ numCards }) => {
  const array = Array.from({ length: numCards }, (v, i) => i);
  return (
    <div className="secure-state-card">
      <div className="row">
        <div className="col-sm-6 col-xs-8">
          <FakeTextInfo height={20} />
        </div>
      </div>
      <div className="row">
        {array.map((item) => (
          <div className="col-xs-12 col-sm-6">
            {/* <Card
              className=""
              borderColor={CARD_COLOR.GREY_3}
              key={`${COMPONENT_NAME} ${item}`}
            > */}
              <FakeIconTextGroup />
            {/* </Card> */}
          </div>
        ))}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default SecureStateCardFake;
